
import {typesNonProd} from './svtypes/nonProd'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    sv_esquery_data : {
        my_esqueryText: "xx",
        STARTDATE:"2023-10-24",
        ENDDATE: "2023-11-27" , 
        time_zone: "+01:00"

      },
    my_esqueryText : "mexco",
    sojourns:[{
        "sojourncode": "200",
        "vernacularcode": "EN",
        "sojourn_name": "200 Mary Resort"
    },
    {
        "sojourncode": "201",
        "vernacularcode": "EN",
        "sojourn_name": "201 John Resort"
    }],
    radio_data: [
        
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ],
    svr_soj_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
   
    my_data: [{
        "sojourncode": "200",
        "vernacularcode": "EN",
        "sojourn_name": "200 Mary Resort"
    },
    {
        "sojourncode": "201",
        "vernacularcode": "EN",
        "sojourn_name": "201 John Resort"
    }]
}

export default (state = initStore, action) => {
    console.log(action);
    let januState, svns;

    switch (action.type) {
        case "sojourns/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case "GET_NON_PROD_SUCCESS":
            console.log("svoct17 SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload);
            console.log("svoct17 end  SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
           
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            if(action.payload.sv_esquery_data){
                januState = {...state, loading: false, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images, sv_esquery_data: action.payload.sv_esquery_data}
            
            }else{
                januState = {...state, loading: false, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images}
            
            }
            return januState
        case "radio-success":
                console.log("radio success");
                console.log(action.payload.my_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, radio_data: action.payload.radio_data}
                return januState
        case typesNonProd.GET_NON_PROD_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesNonProd.GET_NON_PROD_ERROR:
            console.log("error")
            return {...state, error: true}
        default:
            return state
    }
}